
window['eventHR'] = false;
const updateHeartRate = function(userId, userEmail, callback)
{
	
	if ( typeof EventSource == 'undefined' ) { return false; }
	
	if ( window['eventHR'] )
		{
			window['eventHR'].close();
			window['eventHR'] = false;
		}
	
	
	var events = new EventSource(process.env.REACT_APP_API_URL+'/api/v1/updatestatus/updateHeartRate?userId=' + userId + '&userEmail='+userEmail);
	events.onmessage = (event) => {
			if ( event.data )
				{
					try
					{
						if ( event.data == 'first load' || event.data == 'keep-alive' ) { return false; }
						
						var jsondata = JSON.parse(event.data);
						if ( jsondata ) { callback(jsondata); }
					}
					catch (e) { console.log('error parsing JSON ping', e, event); }
				}
		};
	
	console.log('eventHR create');
	
	window['eventHR'] = events;
}

export { updateHeartRate };
